import { useAuthStore } from "@/state/auth-store";

/**
 * Best-effort: push the device's IANA time zone to the server when it differs
 * from what's stored. The reminder-email cron and Mood Jar month boundaries
 * both resolve in this zone, so keeping it current is what makes "8 PM local"
 * actually mean the user's local time. Cheap and idempotent — only writes on a
 * real change.
 */
export async function syncDeviceTimezone(): Promise<void> {
  let tz: string | undefined;
  try {
    tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return; // Intl/timeZone unavailable — nothing we can do.
  }
  if (!tz) return;

  const state = useAuthStore.getState();
  if (!state.user || state.user.timezone === tz) return;

  try {
    await state.setProfile({ timezone: tz });
  } catch {
    // Non-critical; we'll try again next launch.
  }
}
